<div class="ms-progress-bar-information" *ngIf="shouldShowInformation">
    <span class="ms-progress-bar-information-text">{{ informationText }}</span
    ><span #percentage class="ms-progress-bar-information-value" *ngIf="shouldShowPercentage"></span>
</div>
<div class="ms-progress-bar-background-bar"><div #progress class="ms-progress-bar-indicator"></div></div>
